import styled from "styled-components";
import { Card } from "@nubeteck/components";

export const CardBody = styled(Card)`
  &:hover {
    cursor: pointer;
    border: 1px dashed ${({ theme }) => theme.colors.primary500};
  }
`;
